import $ from "jquery";


$(() => {
  $("#post-84966 a.disabled").removeClass("disabled");
});
